const ReportSVG = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4 6C4 3.79086 5.79086 2 8 2H12H14.0633C14.6568 2 15.2197 2.26365 15.5997 2.71963L19.5364 7.44373C19.836 7.80316 20 8.25623 20 8.7241V12V18C20 20.2091 18.2091 22 16 22H8C5.79086 22 4 20.2091 4 18V6Z"
      stroke="#8E8E8E"
      strokeWidth="1.5"
    />
    <path
      d="M15 2.5V6C15 7.10457 15.8954 8 17 8H19.5"
      stroke="#8E8E8E"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 12H16"
      stroke="#8E8E8E"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 17H12"
      stroke="#8E8E8E"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const ReportSVGSelected = () => (
  <svg
    width="18"
    height="22"
    viewBox="0 0 18 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.25 0.25634C11.1881 0.252128 11.1258 0.25 11.0633 0.25H5C2.37665 0.25 0.25 2.37665 0.25 5V17C0.25 19.6234 2.37665 21.75 5 21.75H13C15.6234 21.75 17.75 19.6234 17.75 17V7.75H14C12.4812 7.75 11.25 6.51878 11.25 5V0.25634ZM4.25 11C4.25 10.5858 4.58579 10.25 5 10.25H13C13.4142 10.25 13.75 10.5858 13.75 11C13.75 11.4142 13.4142 11.75 13 11.75H5C4.58579 11.75 4.25 11.4142 4.25 11ZM5 15.25C4.58579 15.25 4.25 15.5858 4.25 16C4.25 16.4142 4.58579 16.75 5 16.75H9C9.41421 16.75 9.75 16.4142 9.75 16C9.75 15.5858 9.41421 15.25 9 15.25H5Z"
      fill="#C44A25"
    />
    <path
      d="M17.3215 6.25C17.2584 6.15059 17.1887 6.0549 17.1126 5.96359L13.1759 1.23949C13.048 1.08601 12.905 0.94837 12.75 0.828021V5C12.75 5.69036 13.3096 6.25 14 6.25H17.3215Z"
      fill="#C44A25"
    />
  </svg>
);

export { ReportSVG, ReportSVGSelected };
